const LAB_ID = 12;
const REPAIR = "/Repair";
const EXERCISE_PATH = "/Lab12/Exercise";
const FORM_REPAIR_HEADING = "Form Repair";
const DATABASE_REPAIR_HEADING = "Database Repair";

const EXERCISE_SELECTION_DEFAULT = "default selection";
const FORM_REPAIR = "FormRepair";
const DATABASE_REPAIR = "DatabaseRepair";

const EXERCISE_STATES = {
  EXERCISE_SELECTION_DEFAULT,
  FORM_REPAIR,
  DATABASE_REPAIR,
};

export {
  LAB_ID,
  REPAIR,
  EXERCISE_PATH,
  FORM_REPAIR_HEADING,
  DATABASE_REPAIR_HEADING,
  FORM_REPAIR,
  DATABASE_REPAIR,
  EXERCISE_STATES,
};

const ALUMNI_NEWSLETTER_CONTENT = `Congratulations on graduating from ALL University! We are proud to have provided each and every student with an education in accessibility.
We look forward to seeing our former students thrive in their careers and carry forward the values we’ve instilled during your time here.
We encourage you to stay connected with your fellow alumni and the university itself.
We hope to see you attend alumni events, participate in mentorship programs and give back to the ALL community.
We will be keeping alumni up to date with various volunteering opportunities and alumni events on campus!
All of us here from ALL University wish you the best of luck and are excited to see where your education takes you!`;

export { ALUMNI_NEWSLETTER_CONTENT };
